var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Signals from '../../signals/Signals';
import assetUpdate from '../../requests/asset/updateIcon';
/**
 *
 */
var UpdateAssetIconCommand = /** @class */ (function (_super) {
    __extends(UpdateAssetIconCommand, _super);
    function UpdateAssetIconCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param assetModel assetModel
     * @param organisationId string
     * @param intl
     * @return {*}
     */
    UpdateAssetIconCommand.prototype.execute = function (assetModel, organisationId, intl) {
        assetModel.iconColorRgba = assetModel.iconColor.rgbNumber();
        this.intl = intl;
        this.assetModel = assetModel;
        var icon = { iconName: this.assetModel.iconName, iconColorRgba: this.assetModel.iconColorRgba };
        var promise = assetUpdate(icon, organisationId, assetModel.getMetricsDbId());
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    UpdateAssetIconCommand.prototype.then = function (response) {
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.asset.updated' }, Object(this.assetModel.properties)), 'dark', true);
    };
    return UpdateAssetIconCommand;
}(Command));
export default UpdateAssetIconCommand;
